<template>

  <p v-if="error" class="error">{{ error }}</p>
  <div class="cell small-12">
    <h1>Payments and Deductions Questionnaire</h1>
    <p>Every business has its own way of handling their employees pay — from standard salaries to extras like overtime, bonuses, or expenses. Likewise, there may be deductions for things like healthcare, cycle-to-work schemes, or repayments.</p>
    <p>To make sure your payroll is set up to match how you operate, we’d like to understand what types of payments and deductions you’ll need to include in your employee pay runs.
    </p>
  </div>


</template>


<script setup>

import { ref } from 'vue'

const error = ref(null)


const props = defineProps({
  formData: Object,
  clientInvite: Object
})


const validateStep = () => {
  return true;
}



const executeStep = async () => {
  return true;
}


defineExpose({ validateStep, executeStep });

</script>